import React, { useEffect }  from "react";
import { connect } from "react-redux";
import ClientTeamTable from "./components/ClientTeamTable";


const ClientTeams = ({clientId}) => {
	
	useEffect(() => {
	}, [clientId]);

	return (
		
	    <div>
			<ClientTeamTable clientId={clientId} />
	    </div>
    );
};

const mapStateToProps = (state) => ({
  	  
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTeams);